import React, { Suspense } from "react";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import './App.css';

function App() {

  const FeedbackOrder = React.lazy(() => import('./pages/FeedbackOrder'));
  const SuccessFeedbackOrder = React.lazy(() => import('./pages/SuccessFeedbackOrder'));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#0171e3',
      },
      secondary: {
        main: '#03a9f4', // Cor secundária (opcional)
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Suspense fallback={<div></div>}>
          <Routes>
            <Route path="/feedback-order/:orderId" element={<FeedbackOrder />} >
              <Route path="/feedback-order/:orderId/success" element={<SuccessFeedbackOrder />} />
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </ThemeProvider>
  );
}

export default App;
